import angular from "angular";

export class TranslationCacheService {

    public static componentName = "TranslationCacheService";
    static $inject = ["$cacheFactory"];

    private cache: angular.ICacheObject;

    constructor(private $cacheFactory: angular.ICacheFactoryService) {
        this.cache = this.$cacheFactory(`translationCache.${TL_BUILD_HASH}`);
    }

    put<T>(key: string, value: T): void {
        this.cache.put(key, value);
    }

    get<T>(key: string): T | undefined {
        return this.cache.get<T>(key);
    }

    remove(key: string): void {
        this.cache.remove(key);
    }

    removeAll(): void {
        this.cache.removeAll();
    }
}

angular.module('topline.modules').service(TranslationCacheService.componentName, TranslationCacheService);